import { DrawerBase } from 'bog-arcade-core-ui/core/DrawerBase';
import { GameLayers } from '../../core/enums';
import { gameAnimations } from '../../services/helperServices/GameAnimationService';
import { gameLayers } from '../../services/helperServices/GameLayersService';
import { gameService } from '../../services/apiServices/GameService';

export class BaseGameDrawer extends DrawerBase {
  constructor(drawers) {
    super();
    this.drawers = drawers;
    this.parent = null;
    this.once = new Set();
    this.mainScene = this.createContainer('mainScene');
    this.screenChangeContainer = this.createContainer('screenChangeContainer');
    this.layers = {
      [GameLayers.breakingBallSpine]: this.createContainer('breakingBallSpine'),
      [GameLayers.particles]: this.createContainer('particles'),
      [GameLayers.allBallsBreakingSpine]: this.createContainer('allBallsBreakingSpine'),
      [GameLayers.dragonForceBack]: this.createContainer('dragonForceBack'),
      [GameLayers.dragonSoulSpine]: this.createContainer('dragonSoulSpine'),
      [GameLayers.waterfallSpine]: this.createContainer('waterfallSpine'),
      [GameLayers.dragonForce]: this.createContainer('dragonForce'),
      [GameLayers.dragonSpine]: this.createContainer('dragonSpine'),
      [GameLayers.background]: this.createContainer('background'),
      [GameLayers.waterSpine]: this.createContainer('waterSpine'),
      [GameLayers.treesSpine]: this.createContainer('treesSpine'),
      [GameLayers.plateSpine]: this.createContainer('plateSpine'),
      [GameLayers.bonusBoard]: this.createContainer('bonusBoard'),
      [GameLayers.wallSpine]: this.createContainer('wallSpine'),
      [GameLayers.fishSpine]: this.createContainer('fishSpine'),
      [GameLayers.gamePad]: this.createContainer('gamePad'),
      [GameLayers.footer]: this.createContainer('footer'),
      [GameLayers.shadow]: this.createContainer('shadow'),
      [GameLayers.balls]: this.createContainer('balls'),
      [GameLayers.ball]: this.createContainer('ball'),
      [GameLayers.buyBonusPopup]: this.createContainer('buyBonusPopup'),
      [GameLayers.congratulationsPopup]: this.createContainer('congratulationsPopup'),
      [GameLayers.bigWinPopup]: this.createContainer('bigWinPopup'),
      [GameLayers.winOdd]: this.createContainer('winOdd'),
      [GameLayers.deposit]: this.createContainer('deposit'),
      [GameLayers.buyBonusButton]: this.createContainer('buyBonusButton'),

      * [Symbol.iterator]() {
        yield this[GameLayers.background];
        yield this[GameLayers.wallSpine];
        yield this[GameLayers.waterSpine];
        yield this[GameLayers.fishSpine];
        yield this[GameLayers.waterfallSpine];
        yield this[GameLayers.treesSpine];
        yield this[GameLayers.plateSpine];
        yield this[GameLayers.dragonForceBack];
        yield this[GameLayers.allBallsBreakingSpine];
        yield this[GameLayers.balls];
        yield this[GameLayers.breakingBallSpine];
        yield this[GameLayers.particles];
        yield this[GameLayers.ball];
        yield this[GameLayers.dragonForce];
        yield this[GameLayers.dragonSpine];
        yield this[GameLayers.shadow];
        yield this[GameLayers.buyBonusButton];
        yield this[GameLayers.dragonSoulSpine];
        yield this[GameLayers.gamePad];
        yield this[GameLayers.footer];
        yield this[GameLayers.winOdd];
        yield this[GameLayers.bonusBoard];
        yield this[GameLayers.congratulationsPopup];
        yield this[GameLayers.buyBonusPopup];
        yield this[GameLayers.bigWinPopup];
        yield this[GameLayers.deposit];
      },
    };

    this.layerSetupState = false;
    this.isDraw = false;
  }

  setupLayers() {
    if (!this.layerSetupState) {
      this.layerSetupState = true;
      gameLayers.layers = this.layers;
      this.parent.addChild(
        ...this.layers,
      );
    }
  }

  setupApplicationLayers() {
    this.drawers.background.application.setupLayers(this.layers);
    this.drawers.balls.application.setupLayers(this.layers);
    this.drawers.gamePad.application.setupLayers(this.layers);
    this.drawers.bonusBoard.application.setupLayers(this.layers);
  }

  defineParent(parent) {
    this.parent = parent;
  }

  draw() {
    if (this.isDraw) return;
    this.drawers.background.application.setBackground();
    this.drawers.background.application.setShadow();
    this.drawers.background.application.setDragonForceBack();
    this.drawers.background.application.setDragonForce();
    this.drawers.background.application.setStaticAnimations();
    setTimeout(() => {
      this.drawers.balls.application.execute();
    }, 3000);
    this.drawers.gamePad.application.execute();
    this.drawers.bonusBoard.application.execute();
    this.drawers.congratulationsPopup.execute({ root: this.layers[GameLayers.congratulationsPopup] });
    this.drawers.buyBonus.execute({ root: this.layers[GameLayers.buyBonusPopup] });
    this.drawers.bigWin.execute({ root: this.layers[GameLayers.bigWinPopup] });
    this.isDraw = true;
  }

  async execute({ scene, parent, prevScene }) {
    await this.loadResource();
    this.setupLayers();
    this.setupApplicationLayers();
    this.draw();

    if (gameService.isBonus) {
      gameLayers.showDragonSoul();
      gameLayers.showBonusBoard();
      gameLayers.hideGamePad();
      gameLayers.hideBackgroundPlate();
      gameAnimations.dragonSoulAppearAndLoop();
    }

    if (!gameService.isBonus) {
      gameLayers.hideDragonSoul();
      gameLayers.hideBonusBoard();
      gameLayers.showGamePad();
      gameLayers.showBackgroundPlate();
    }
  }
}
